export default __webpack_public_path__ + "static/media/ir.2ab9c0de.svg";